import React from 'react';
import { pathManager } from 'routes';

import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Button, Fade, Menu, MenuItem } from '@mui/material';

import { Job } from '@libs/graphql-types';

import { useCopyAction } from './hooks';

interface ShareButtonProps {
  job?: Job;
  className?: string;
}

const ShareButton = ({ job, className }: ShareButtonProps) => {
  const link = `${window.location.origin}${pathManager.public.job.generatePath({
    id: job?.id || '',
  })}`;
  const onCopy = useCopyAction({ link });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="share-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ShareOutlinedIcon />}
        variant="outlined"
        color="info"
        disabled={job?.is_archived}
        fullWidth
        className={className}
      >
        Share
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'share-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem component="a" target="_blank" href={link}>
          Visit
        </MenuItem>
        <MenuItem
          onClick={() => {
            onCopy();
            handleClose();
          }}
        >
          Copy url
        </MenuItem>
      </Menu>
    </div>
  );
};

export default ShareButton;
